import { render, staticRenderFns } from "./CallSettingsTab.vue?vue&type=template&id=09d9350f&scoped=true"
import script from "./CallSettingsTab.vue?vue&type=script&lang=js"
export * from "./CallSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./CallSettingsTab.vue?vue&type=style&index=0&id=09d9350f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9350f",
  null
  
)

export default component.exports